export const HTML_MEDIA_CONTENT_FETCH_REQUEST = 'HTML_MEDIA_CONTENT_FETCH_REQUEST';
export const HTML_MEDIA_CONTENT_FETCH_SUCCESS = 'HTML_MEDIA_CONTENT_FETCH_SUCCESS';
export const HTML_MEDIA_CONTENT_FETCH_FAILURE = 'HTML_MEDIA_CONTENT_FETCH_FAILURE';